export default "__VITE_ASSET__DWWDZCyC__"